import Icon from '../components/Icon.vue'

Icon.register({
  wheelchair: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496.1 385.7L510.3 414.3C514.3 422.2 511 431.8 503.1 435.8L437.6 468.7C421.6 476.6 402.1 469.9 394.5 453.6L331.7 320H192C176.1 320 162.6 308.3 160.3 292.5 126.4 55.3 128.4 70 128 64 128 27.6 158.3-1.6 195.1 0.1 228.3 1.6 255.1 29 256 62.3 256.8 95.2 232.8 122.7 201.4 127.3L206 160H336C344.8 160 352 167.2 352 176V208C352 216.8 344.8 224 336 224H215.2L219.8 256H352A32-32 0 0 0 381 274.4L438.5 396.8 474.7 378.5C482.6 374.5 492.2 377.8 496.1 385.7zM311.4 352H286.9C279.1 406.2 232.3 448 176 448 114.2 448 64 397.8 64 336 64 294.5 86.7 258.2 120.3 238.8 116.6 212.9 113.5 191 110.8 172.5 46 198.5 0 262 0 336 0 433 79 512 176 512 247.9 512 309.8 468.7 337.1 406.8L311.4 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wheelchair.js
// module id = 6ZQ3
// module chunks = 144